/* eslint-disable no-restricted-exports, unicorn/no-anonymous-default-export */
import type { RouteLocationNormalized } from "vue-router";

export default (to: RouteLocationNormalized) =>
    typeof to.name === "string" &&
    ["slug-entrance", "slug-login", "slug-reset-password-token"].includes(
        to.name,
    );
